import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { BackgroundV2 } from '@alfa-bank/site-background-v2';
import { CalculatorMIcon } from '@alfalab/icons-glyph/CalculatorMIcon';
import { ShareCompactMIcon } from '@alfalab/icons-glyph/ShareCompactMIcon';
import { IconButton } from '@alfa-bank/site-icon-input/icon-button';
import { getCorrectSuffix } from '@alfa-bank/site-form-helpers/text/get-correct-suffix';
import { LinkPid as Link } from '@alfa-bank/site-link/link-pid';

import type { IDepsDesktop, TPilOfferCardDesktop } from '../models';

import { PilOfferCardDesktop as Component } from './component';
import styles from './desktop.css';

export const PilOfferCardDesktop = createWidget<IDepsDesktop, TPilOfferCardDesktop>({
    getCorrectSuffix,
    styles,
    CalculatorMIcon,
    IconButton,
    ShareCompactMIcon,
    Text,
    Button,
    Link,
    BackgroundV2,
    Grid,
})(Component);
